import React from 'react';
import { Paper, Grid } from '@mui/material';
import { EditSharp } from '@mui/icons-material';
import useTranslation from 'Hooks/useTranslation';
import { iconStyle, titleStyle, textStyle } from './style';

export default function EmptyModules() {
  const { t2 } = useTranslation('EditCourse');

  return (
    <Paper style={{ width: '50%', margin: 'auto', marginTop: '10%' }}>
      <Grid container style={{ textAlign: 'center', fontFamily: 'metropolis' }}>
        <Grid item xs={12}>
          <Paper style={iconStyle}>
            <EditSharp fontSize="large" />
          </Paper>
        </Grid>
        <Grid item xs={12} style={{ margin: '2rem 0 0 0' }}>
          <h2 style={titleStyle}>{t2('LetsStart')}</h2>
        </Grid>
        <Grid item xs={12} style={{ margin: '2rem 0 3rem 0' }}>
          <h4 style={textStyle}>{t2('LessonMessage')}</h4>
        </Grid>
      </Grid>
    </Paper>
  );
}
